const DiscountTag = ({content}) => {
    return (
        <div className={'discount-banner'}>
            <span className={'discount-text'}>{content?.discountText}</span>
        </div>
    )
}

export default DiscountTag